"use client";

import { Banner } from "@/components/sections/Banner";
import { getCloudinaryUrl } from "@/lib/cloudinary";
import { cookiesData } from "./data/cookies";

const CookiesPage = () => {
  return (
    <section>
      <Banner title="Gestion des Cookies" backgroundImage={getCloudinaryUrl("salon-banner")} />

      <div className="mx-auto px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <div className="space-y-12">
          {cookiesData.map((section, index) => (
            <div key={index} className="space-y-4">
              <h2 className="text-2xl font-bold">{section.title}</h2>
              {section.content.map((content, contentIndex) => (
                <div key={contentIndex}>
                  {content.text && <p>{content.text}</p>}
                  {content.items && (
                    <ul className="ml-6 list-disc space-y-2">
                      {content.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CookiesPage;
